import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=5c708fb2&scoped=true"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c708fb2",
  null
  
)

export default component.exports